import clsx from "clsx";
import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";

// Multi-file drop zone of SCR-01. Deliberately no `types`: every chosen file reaches recognition (AC-03).
function DropZone({ onFiles, atLimit = false, title, caption }) {
  const [dragging, setDragging] = useState(false);

  return (
    <FileUploader
      multiple
      disabled={atLimit}
      handleChange={(files) => onFiles(Array.from(files))}
      onDraggingStateChange={setDragging}
      hoverTitle=" "
      classes="block w-full"
    >
      <div
        className={clsx(
          "flex flex-col items-center justify-center gap-1 rounded-2xl border-2 border-dashed px-6 py-10 text-center",
          atLimit ? "border-[#e2e2e2] bg-gray-75 cursor-not-allowed" : "border-cyan-75 bg-white cursor-pointer",
          dragging && "border-cyan-450 bg-[#e8f6f8]",
        )}
      >
        <span className="text-sm font-medium text-[#14171a]">{title}</span>
        <span className="text-xs text-[#8c8c8c]">{caption}</span>
      </div>
    </FileUploader>
  );
}

export default DropZone;
